import {SWITCH_BASE_LAYER} from './actions';

export const VECTOR_BASE_LAYER = 'vectorLayer';
export const SATELITE_MAP_LEVEL = 13;

export const getActiveLayer = (baseLayersState) => {

	if(baseLayersState.active === 'wmsLayer') {
	  var activeLayer = VECTOR_BASE_LAYER;
	} else {
	  var activeLayer = baseLayersState.active;
	}

	return activeLayer;
}

const DefaultState = {
  layers: ['wmsLayer', 'wmsBWLayer','photoLayer', 'topoLayer', 'topo75Layer', 'lidarLayer'],//, VECTOR_BASE_LAYER
  active: 'wmsLayer'
};


const baseLayers = (state = DefaultState, action) => {
  switch (action.type) {

    case SWITCH_BASE_LAYER:

      return Object.assign({}, state, {active: action.data});
  
    default:
      return state;
  }
};

export {baseLayers};